export default "/images/10 Step2Plan-Consultant-To view completed self-assessments-02.png?f4c6bd032c736e0c27da9287aecef618";